module.exports = __webpack_public_path__ + "img/image14@2x.fceb59cd.png";